module.exports = __webpack_public_path__ + "static/media/training instructor.e28f88db.png";